export function toggleMenu(){
  return function(dispatch){
    dispatch({type:"TOGGLE_MENU", payload: ''});
  }
}
